import server from '../utils/server';

// Actions

const FETCH_PROPERTIES_SUCCESS = 'properties/FETCH_PROPERTIES_SUCCESS';

// Reducer

const initialState = [];

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_PROPERTIES_SUCCESS: {
      return action.properties;
    }
    default: {
      return state;
    }
  }
}

// Action Creators

const fetchPropertiesSuccess = properties => ({
  type: FETCH_PROPERTIES_SUCCESS,
  properties,
});

// Thunks

export const fetchProperties = () => async dispatch => {
  const json = await server.get('/api/v1/properties');
  dispatch(fetchPropertiesSuccess(json.properties));
};
